function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWisdom = function SvgWisdom(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "-101.8 -63.2 166.4 215",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    cx: -18.4,
    cy: 81.8,
    r: 31
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M57.1,66.7     c0.3-11.1-1.1-22.5-3.8-33.6C45.3,0,26.8-37-2.9-55.7C4-42.3,5.1-26.5,2.7-11.8C0.9-0.7-3.4,11-13,17.6c-9.4,6.5-23.1,7.2-33.1,1.5     C-57.3,12.6-63-0.4-65.2-12.6c-9.7,13.9-18,27.6-23.2,43.8c-3.7,11.4-5.9,23.4-5.8,35.4h0c0,42.9,33.9,77.6,75.7,77.6     S57.1,109.5,57.1,66.7L57.1,66.7z"
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWisdom, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wisdom.3633d122.svg";
export { ForwardRef as ReactComponent };